import React, {useContext} from "react";
import PropTypes from "prop-types";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

// Contexts
import {SettingsContext} from "../../contexts/settings.js";

// Utils
import {prettyDateInUserTimezone} from "../../utils/helpers.js";

// Components
import Modal from "../../components/Modal.js";
import InputDate from "../../components/form/InputDate.js";

// Style
import {breakpoint} from "../../style/components/breakpoints.js";
import {Button, Form, FormField, FormGroup} from "../../style/components/general.js";

const schema = yup.object().shape({
  expiration: yup.string().required("Please provide expiration date.")
});

const ModalRowExpiration = ({visible, setVisible, goBack, update, expiration}) => {
  const {settings} = useContext(SettingsContext);

  const form = useForm({
    defaultValues: {
      expiration: prettyDateInUserTimezone(expiration, settings?.timezone, "YYYY-MM-DD")
    },
    resolver: yupResolver(schema)
  });
  const {handleSubmit} = form;

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      hasBackButton={!!goBack}
      goBack={goBack}
      width={breakpoint.width[1]}>
      <FormProvider {...form}>
        <Form onSubmit={handleSubmit(update)} noValidate>
          <FormGroup>
            <FormField>
              <InputDate label="Expiration Date" name="expiration" />
            </FormField>
          </FormGroup>
          <Button type="submit">Save</Button>
        </Form>
      </FormProvider>
    </Modal>
  );
};

ModalRowExpiration.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  expiration: PropTypes.string,
  goBack: PropTypes.func
};

export default ModalRowExpiration;
